import React from "react";
import styled from "styled-components";
import { _ } from "js/vendor";
import { getSymbolCmdOrCtrl, getSymbolOptOrAlt } from "../core/utilities/utilities";
import isConnected from "js/core/utilities/isConnected";
import { ShowOfflineDialog } from "js/react/components/Dialogs/BaseDialog";
import { SearchBar } from "js/react/views/AddSlide/Panes/Components/SearchBox";
import { t } from "js/i18n";
const Block = styled.div`
    background: #FFF;
    padding: 10px;
    margin-bottom: 10px;
`;

const ScrollBox = styled.div`
    height: calc(100% - 90px);
    overflow-y: auto;
    margin: 10px 0;
`;

const Button = styled.button`
    width: 100%;
    height: auto;
    color: #11a9e2;
    padding: 10px 16px;
    font-family: "Source Sans Pro", sans-serif;
    font-size: 12px;
    border: none;
    cursor: pointer;
    background: #fff;
    text-transform: uppercase;
    font-weight: 600;

    &:hover {
        color: #333;
    }
`;

const Section = styled.div`
    padding-bottom: 0;
    margin-bottom: 10px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
`;

const ShortcutItem = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-size: 14px;
`;

const ShortcutItemLabel = styled.div`
    color: #777;    
`;

const ShortcutItemShortcut = styled.div`
    color: #11a9e2;
    margin-left: 20px;
`;

const ShortcutItemSeparator = styled.span`
    font-size: 12px;
    color: #aaa;
    margin: 0 4px;
`;

class ShortcutContentComponent extends React.Component {
    getCategoriesConfig() {
        return {
            [t("Essentials")]: {
                [t("Copy")]: `${getSymbolCmdOrCtrl()} C`,
                [t("Cut")]: `${getSymbolCmdOrCtrl()} X`,
                [t("Duplicate")]: `${getSymbolCmdOrCtrl()} D`,
                [t("Paste")]: `${getSymbolCmdOrCtrl()} V`,
                [t("Undo")]: `${getSymbolCmdOrCtrl()} Z`,
                [t("Redo")]: `${getSymbolCmdOrCtrl()} Shift Z`,
                [t("Find and Replace")]: `${getSymbolCmdOrCtrl()} F`,
            },
            [t("Text")]: {
                [t("Bold")]: `${getSymbolCmdOrCtrl()} B`,
                [t("Italicize")]: `${getSymbolCmdOrCtrl()} I`,
                [t("Add Link")]: `${getSymbolCmdOrCtrl()} K`,
            },
            [t("Navigation")]: {
                [t("Next Slide")]: (
                    <>
                        <span>&#9654;</span>
                        <ShortcutItemSeparator>{t("OR")}</ShortcutItemSeparator>
                        <span>&#9660;</span>
                    </>
                ),
                [t("Prev Slide")]: (
                    <>
                        <span>&#9664;</span>
                        <ShortcutItemSeparator>{t("OR")}</ShortcutItemSeparator>
                        <span>&#9650;</span>
                    </>
                ),
                [t("Close Present Mode")]: `Esc`,
                [t("Next Item")]: `Tab`,
                [t("Org View")]: `Space`,
            },
            [t("Classic Slides")]: {
                [t("Add Text")]: `T`,
                [t("Add Rectangle")]: `R`,
                [t("Add Oval/Circle")]: `O`,
                [t("Add Path")]: `P`,
                [t("Duplicate Element")]: `${getSymbolCmdOrCtrl()} D`,
                [t("Group Elements")]: `${getSymbolCmdOrCtrl()} G`,
                [t("Ungroup Elements")]: `${getSymbolCmdOrCtrl()} Shift G`,
                [t("Send To Back")]: `${getSymbolCmdOrCtrl()} ${getSymbolOptOrAlt()} [`,
                [t("Bring To Front")]: `${getSymbolCmdOrCtrl()} ${getSymbolOptOrAlt()} ]`,
            }
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            searchTerm: "",
        };
    }

    getFilteredCategories() {
        const searchTerm = this.state.searchTerm.toLowerCase();
        const results = {};
        const categories = this.getCategoriesConfig();

        Object.entries(categories).forEach(([categoryName, entries]) => {
            const category = {};
            const matchCategoryName = categoryName.toLowerCase().includes(searchTerm);
            Object.entries(entries).forEach(([label, shortcut]) => {
                const match = (
                    matchCategoryName ||
                    label.includes && label.toLowerCase().includes(searchTerm) ||
                    shortcut.includes && shortcut.toLowerCase().includes(searchTerm)
                );
                if (match) category[label] = shortcut;
            });
            if (!_.isEmpty(category)) results[categoryName] = category;
        });

        return results;
    }

    handleSearch(value) {
        this.setState({
            searchTerm: value,
        });
    }

    render() {
        const categories = this.getFilteredCategories();

        return (<>
            <Block>
                <SearchBar
                    onSearch={value => this.handleSearch(value)}
                    style={{ padding: "10px 0" }}
                />
            </Block>

            <ScrollBox>
                {
                    Object.entries(categories).map(([categoryName, category]) => (
                        <Block key={categoryName}>
                            <Section>{categoryName}</Section>
                            {
                                Object.entries(category).map(([label, shortcut]) => (
                                    <ShortcutItem key={label}>
                                        <ShortcutItemLabel>{label}</ShortcutItemLabel>
                                        <ShortcutItemShortcut>{shortcut}</ShortcutItemShortcut>
                                    </ShortcutItem>
                                ))
                            }
                        </Block>
                    ))
                }
            </ScrollBox>

            <Button
                onClick={() => {
                    if (!isConnected.connected) {
                        ShowOfflineDialog();
                        return;
                    }
                    window.open("https://support.beautiful.ai/hc/en-us/articles/360000193552-Keyboard-Shortcuts", "_blank", "noopener");
                }}
            >{t("See FAQ")}</Button>
        </>);
    }
}

export const ShortcutContent = ShortcutContentComponent;
